import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import IconWrap from '@bridebook/ui/src/components/svg/icon-wrap';
import { IStylingProps } from '@bridebook/ui/src/themes/types';
import { TColor } from '@bridebook/ui/src/types';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconPlannerIllustration = ({ id, color, width = 161, style, ...restProps }: IProps) => {
  const viewBoxWidth = 161;
  const viewBoxHeight = 172;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      width={`${width}px`}
      height={`${height}px`}>
      <circle cx="80.5" cy="92" r="80" fill="#EDEEFC" />
      <rect x="38.5" y="44" width="88" height="104" rx="5" fill="#7175E9" />
      <rect x="46.5" y="52" width="68" height="88" rx="3" fill="#D9D9D9" />
      <rect x="50.5" y="48" width="68" height="88" rx="3" fill="white" />
      <rect x="60.5" y="38" width="44" height="16" rx="1" fill="#D9D9D9" />
      <rect x="72.5" y="32" width="20" height="16" rx="3" fill="#D9D9D9" />
      <path
        d="M85.3788 63.457C84.7499 63.4666 84.1386 63.6659 83.6249 64.029C83.1112 64.392 82.7191 64.9018 82.5 65.4915C82.2808 64.901 81.8882 64.3907 81.3736 64.0276C80.8591 63.6645 80.2468 63.4656 79.6171 63.457C78.7384 63.5577 77.9298 63.9858 77.3525 64.656C76.7752 65.3263 76.4716 66.1895 76.5021 67.0737C76.5021 71.0346 81.6997 74.257 82.5 74.257C83.3004 74.257 88.4979 71.0346 88.4979 67.0737C88.5283 66.1889 88.2241 65.3251 87.646 64.6548C87.0679 63.9844 86.2583 63.5567 85.3788 63.457Z"
        fill="#FF766A"
      />
      <rect x="60.5" y="106" width="48" height="4" rx="1" fill="#DBDCF9" />
      <rect x="60.5" y="82" width="48" height="4" rx="1" fill="#DBDCF9" />
      <rect x="60.5" y="114" width="48" height="4" rx="1" fill="#DBDCF9" />
      <rect x="60.5" y="90" width="48" height="4" rx="1" fill="#DBDCF9" />
      <rect x="60.5" y="122" width="38" height="4" rx="1" fill="#DBDCF9" />
      <path
        d="M76.9975 4.97519C76.7311 2.31142 78.8229 0 81.5 0C84.1771 0 86.2689 2.31142 86.0025 4.97519L84.7985 17.0149C84.6291 18.7095 83.2031 20 81.5 20C79.7969 20 78.371 18.7095 78.2015 17.0149L76.9975 4.97519Z"
        fill="#F9DDB0"
      />
      <path
        d="M47.4515 19.2043C45.8506 17.0852 46.4676 14.0427 48.7676 12.7148C51.0676 11.3869 54.011 12.3738 55.0457 14.8198L58.2583 22.4146C58.9258 23.9926 58.3129 25.8208 56.829 26.6775C55.3451 27.5343 53.4554 27.151 52.4225 25.7839L47.4515 19.2043Z"
        fill="#F9DDB0"
      />
      <path
        d="M114.799 18.2479C116.388 16.1103 115.757 13.0659 113.451 11.7344C111.145 10.4029 108.193 11.3793 107.136 13.8235L103.416 22.4247C102.737 23.9942 103.342 25.8232 104.823 26.6782C106.304 27.5332 108.191 27.1427 109.211 25.7701L114.799 18.2479Z"
        fill="#F9DDB0"
      />
      <path
        d="M134.5 39.1962C136.157 36.3264 139.826 35.3431 142.696 37C145.566 38.6569 146.549 42.3264 144.892 45.1962L119.392 89.3634C119.116 89.8417 118.505 90.0056 118.026 89.7295L109.366 84.7295C108.888 84.4533 108.724 83.8417 109 83.3634L134.5 39.1962Z"
        fill="#1A2C40"
      />
      <path
        d="M104.893 90.4784C103.981 92.0568 103.516 93.8531 103.547 95.6754L103.696 104.551L111.457 100.242C113.051 99.3578 114.374 98.0568 115.285 96.4784L117.312 92.9678C117.974 91.8208 117.931 90.3981 117.202 89.2929C117.174 89.2517 117.138 89.2174 117.095 89.1928L110.297 85.2678C110.254 85.2431 110.206 85.2287 110.157 85.2258C108.835 85.1464 107.582 85.8208 106.919 86.9678L104.893 90.4784Z"
        fill="#D9D9D9"
      />
      <path d="M109.703 94.1562L105.703 101.084" stroke="black" strokeLinecap="round" />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconPlannerIllustration;
